<template>
	<popup class="add-funnel-popup" :class="{'wide':step===3}" title="Add new funnel" @close="closePopup" noscroll>
		<template v-slot:content>
			<div class="content scroll" v-if="step!==3">
				<label class="form_steps_label step_1" :class="{'active': step !== 1}">
					<span class="icon"></span> Select a funnel type
				</label>
				<div class="funnel_type_radio_wrpr" :class="{'active': step == 1}">
					<label class="funnel_type_radio ">
						<!--	                value="1" v-model.number="funnelType" @click="continueBtnDisabled = false"-->
						<input type="radio" name="funnel_type_radio" :value="1" v-model.number="funnelType">
						<div class="funnel_type_radio_box funnel_type_radio_1">
							<div class="funnel_type_radio_box_header" style="height: 35px;">
								<div class="funnel_type_radio_logo">
									<inline-svg :src="require('@/assets/img/Funnelish Plus.svg')" />
								</div>
								<span class="orange_badge">New</span>
							</div>
							<div>
								<p>Use our funnel builder to create your unique eCommerce funnel</p>
								<ul class="plus-features">
									<li>Loads 10x faster than Clickfunnels.</li>
									<li>Converts 35%+ more than Clickfunnels.</li>
								</ul>
							</div>
						</div>
					</label>
					<label class="funnel_type_radio">
						<input type="radio" name="funnel_type_radio" value="0" v-model.number="funnelType" @click="continueBtnDisabled = false">
						<div class="funnel_type_radio_box funnel_type_radio_2">
							<div class="funnel_type_radio_logo">
								<img src="@/assets/img/funnel_type_radio_logo_2.svg" alt="">
							</div>
							<p>Connect your existing Clickfunnels funnel to our apps and integrations to improve your conversions.</p>
						</div>
					</label>
				</div>
				<div class="funnel_details_step" :class="{'active': step === 2}">
					<label class="form_steps_label step_2" :class="{'active': funnelDetailsStepInput}">
						<span class="icon"></span> Your funnel details
					</label>
					<div class="form-group">
						<input type="text" class="control-input" placeholder="Set a funnel name" v-model="funnelDetailsStepInput">
					</div>
				</div>
<!--				<div class="info-message margin-t-10" v-if="!canFPlus">-->
<!--					<router-link to="billing/choose-your-plan" style="text-decoration: underline;">-->
<!--						Upgrade your account-->
<!--					</router-link>-->
<!--					to a <b>Funnelish™ Plus</b> plan to create Funnelish™ Plus funnels.-->
<!--				</div>-->
			</div>

			<div v-else class="content noscroll">
				<label class="form_steps_label step_3" :class="{'active': funnelDetailsStepInput}">
					<span class="icon"></span> Select a funnel template
				</label>
				<div class="templates-container layout-column flex noscroll">
					<templates @selected="funnelToClone=$event" />
				</div>
			</div>

			<div class="flex-center layout-column">
				<cloning-funnel-popup v-if="cloning" :folder="folder" :funnel="funnelToClone.funnel_id" :code="funnelToClone.share_code"
				                      :name="funnelToClone.name" :cloneGeoFunnels="funnelToClone.clone_geo_funnels"
				                      @done="doneCloneFunnel" @failed="cloning=false"/>
			</div>

		</template>

		<template v-slot:actions>
			<span v-if="step===3" class="sub-headline">
				We are adding and improving funnel templates on a daily basis.<br>
				Recommend new funnel ideas or improvements on our
				<a target="_blank" href="https://community.funnelish.com">community</a>.
			</span>

			<v-button border @click="step -= 1" label="Back" v-if="step !== 1"/>

			<v-button v-if="step===1" @click="gotoNextStep()" label="Continue" />

			<v-button v-if="step===2&&funnelType!==1" label="Add new funnel" @click="addFunnel"
			          :loading="saving" :disabled="!funnelDetailsStepInput"/>
			<v-button v-else-if="step===2" label="Continue" @click="step=3" :disabled="!funnelDetailsStepInput"/>

			<v-button v-if="step===3" label="Create funnel" :loading="cloning" @click="cloneFunnel" />

			<v-button @click="closePopup" label="Cancel" border />
			<subdomain-popup v-if="subdomainOpen" :canClose="false" @close="subdomainOpen=false" />
		</template>
	</popup>
</template>

<script>
import API from "@/api"
import VButton from "@/components/base/v-button";
import SubdomainPopup from "@/components/popups/subdomain-popup";
import Templates from "@/views/funnels/funnel-plus/funnel/templates";
import Popup from "@/components/base/popup";
import CloningFunnelPopup from "@/views/funnels/funnel-plus/funnel/cloning-funnel-popup";
export default {
	name: "AddNewFunnelPopup",
  components: {CloningFunnelPopup, Popup, Templates, SubdomainPopup, VButton},
  mixins: [API],
	props:{
		folder:{},
	},
    data() {
        return {
	        subdomainOpen: false,
          saving: false,
	        cloning: false,
	        funnelToClone: {},
            step: 1,
            continueBtnDisabled: false,
            funnelDetailsStepInput: '',
            funnelType: 1,
        }
    },
		computed:{
	      user() {
	      	return this.$store.state.userInfo;
	      },
			// canFPlus() {
			// 	return this.user && this.user.attributes['plan-key'] && this.user.attributes['plan-key'] !== 'funnelish-apps';
			// }
		},
    methods: {
	    doneCloneFunnel(funnel) {
		    this.$router.push({path: `/wfunnel/${funnel.id}`});

		    this.funnelToClone= {};
		    this.cloning=false;
		    this.closePopup()
	    },
    	gotoNextStep() {
		    this.step = 2;
		    if (this.funnelType===1) {
		    	// check if user has a subdomain already if not ask them to create one first!
			    if (!this.user.subdomain) {
				    this.subdomainOpen = true;
			    }
		    }
	    },
        closePopup() {
            this.$emit('close')
        },
        async addFunnel() {
          try {
            this.saving = true;
						let folder_id = this.folder ? this.folder.id : null;

            let data = {
              "name": this.funnelDetailsStepInput,
              "funnel_type": this.funnelType,
              "funnel_url": "www",
              "notify_url": null,
              "paypal_id": null,
              "created_at": null,
              "updated_at": null,
              "currency_code": null,
              "order_index": null,
              "owner": null,
	            folder_id
            }
            let result = await this.api.funnels.create(data);
            this.closePopup()
            if (this.funnelType === 0) {
              this.$router.push({path: `/funnel/${result.id}`});
            } else {
              this.$router.push({path: `/wfunnel/${result.id}`});
            }
          } catch (e) {
            this.$error(e);
          } finally {
            this.saving = false;
          }
        },
	    async cloneFunnel() {
    		this.funnelToClone.name = this.funnelDetailsStepInput;
    		this.cloning = true;
	    }
    }
}
</script>
<style lang="scss">
.add-funnel-popup {
	&.wide {
		.popup {
			width: 1200px;
			max-width: 1200px;
			.content{
				padding: 5px;
			}
		}
	}
	.content {
		padding: 10px 10px 5px;
		overflow: hidden;
		height: 100%;
	}
	.form_steps_label.step_3 {
		margin-bottom: 0;
	}
}
</style>
<style lang="scss" scoped>
.sub-headline {
	font-weight: 400;
	font-size: 12px;
	display: block;
	flex: 1;
	line-height: 140%;
}
.funnel_type_radio {
	.funnel_type_radio_logo {
		svg {
			height: 30px;
		}
	}
  &.disabled {
    opacity: 0.8;
    pointer-events: none;
  }
}
ul.plus-features {
	line-height: 1.7;
	font-weight: 600;
	list-style: disc inside;
	margin-top: 5px;
}

</style>
